<template>
  <div>
    <div class="Hoarding" @click="hide">
      <img class="tool-icon" :src="
        isGather
          ? require('@/assets/img/mobile-img/iscollect-icon.png')
          : require('@/assets/img/mobile-img/collect-icon.png')
      " alt="" />
      <span>收藏</span>
    </div>
    <div v-if="toast !== ''" class="toast">
      <span>{{ toast }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "Hoarding",
  props: ["shareInfo"],
  data() {
    return {
      isGather: false, // 是否已收藏
      toast: "",
      loding: false,
    };
  },
  created() {
    // 初始化是否登陆之后判断是否已收藏
    if (sessionStorage.getItem("token")) this.isCollect();
  },
  mounted() {
    // 进行监听sessionStorage
    window.addEventListener("setItem", () => {
      if (
        sessionStorage.getItem("token") &&
        (this.$route.name === "bookDetails" ||
          this.$route.name === "courseDetails" ||
          this.$route.name === "ReportDetails")
      ) {
        this.isCollect();
      }
    });
    // 接收APP传递的数据
    window.getCollect = (data) => {
      if (this.$global.isAndroid_ios()) {
        this.isGather = data.body.value == "true" ? true : false;
        sessionStorage.setItem("isCollect", data.body.value);
      } else {
        if (typeof data == "string") {
          this.isGather = JSON.parse(data).body.value;
          sessionStorage.setItem("isCollect", JSON.parse(data).body.value);
        }
      }
    };
  },
  methods: {
    // 收藏按钮
    hide() {
      if (sessionStorage.getItem("token")) {
        this.CollectItem();
      } else {
        if (this.$route.query.out) {
          if (this.$global.isAndroid_ios()) {
            window.android.getToken();
          } else {
            window.webkit.messageHandlers.getToken.postMessage("null"); //ios
          }
        } else {
          this.$router.push("/logins");
        }
      }
    },
    // 收藏接口
    async CollectItem() {
      if (this.loding) return;
      this.loding = true;
      let res = {
        data: null,
      };
      // 如果是图书详情页收藏
      if (this.$route.name === "bookDetails" || this.$route.name === "ReportDetails") {
        res.data = await this.$apis.recomendServe.bookToCollect({
          bookId: this.shareInfo.goodsId,
          goodsTypeId: this.shareInfo.goodsTypeId,
        });
      } else {
        res = await this.$apis.recomendServe.CollectItemAPP({
          action: this.isGather ? 0 : 1, // 0未收藏 1已收藏
          articleId: this.shareInfo.articleId,
          articleType: this.shareInfo.articleType,
        });
      }
      if (res.data.resultCode === "200") {
        // 调用成功
        clearInterval(this.toastTime);
        this.toastTime = setTimeout(() => {
          this.toast = "";
          this.loding = false;
        }, 1000);
        if (this.isGather) {
          this.toast = "取消收藏";
        } else {
          this.toast = "收藏成功";
        }
        this.isGather = !this.isGather;
        sessionStorage.setItem("isCollect", this.isGather);
      }
    },
    // // 判断是否收藏
    async isCollect() {
      // 如果是图书详情页收藏
      if (
        this.$route.name === "bookDetails" ||
        this.$route.name === "courseDetails" ||
        this.$route.name === "ReportDetails"
      ) {
        this.isGather = sessionStorage.getItem("isCollect") === "true";
      } else {
        const resp = await this.$apis.recomendServe.isCollect({
          articleId: this.$route.query.id,
          articleType: this.$route.query.type,
        });
        sessionStorage.setItem("isCollect", resp.isCollect);
        this.isGather = resp.isCollect;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.Hoarding {
  display: flex;
  align-items: center;
  font-size: 15px;
  font-weight: 400;
  color: #333333;
  line-height: 21px;

  .tool-icon {
    margin-right: 10px;
    width: 19px;
    height: 19px;
  }
}

.toast {
  width: 100%;
  height: 30px;
  position: fixed;
  left: 0;
  bottom: 50%;
  z-index: 999;
  text-align: center;
  color: #fff;
  line-height: 30px;

  & span {
    display: inline-block;
    height: 30px;
    padding: 0 30px;
    border-radius: 10px;
    background: rgba(0, 0, 0, 0.486);
  }
}
</style>
